import { Container, Navbar, Dropdown } from "react-bootstrap"
import Logo from '../../assets/images/shan_and_co_logo.png'
import avtar from '../../assets/images/avtar-male.png'
import { GoChevronDown } from "react-icons/go";
const Header = () => {
    return(
        <>
            <header className="site-header">
              
                </header>
        
        </>
    )
}
export default Header;